






























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { inverterService, plantService } from "@/services";
import AddCusttomers from "./addcustomer.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
  });
}
extend("required", {
  message: "Required Field",
  validate(value: any) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  computesRequired: true,
});
extend("max_value", {
  message: "Invalid range",
});

@Component({
  name: "app-component",
  props: {
    message: String,
  },
  components: {
    AddCusttomers,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class ManageInverter extends Vue {
  @Prop() private msg!: string;
  values: any = {};
  data: any = [];
  constructor() {
    super();
  }

  public inverterList: any = [];
  public inverterCompanyDetail: any = [];
  private plantID: any = 0;
  private deviceID: any = 0;
  private selectedIndex: any = null;
  private inverterSerialID = 0;
  private maxPower = 0;
  private companyName = "";
  private notFound: string = "";

  mounted() {
    this.plantID = this.$route.params.id;
    plantService.getPLantById(this.plantID).then((response: any) => {
      this.inverterList = response.data.plant_object.inverters_data;
    });
    this.getDevice();
  }
  getInverterDetail(item: any, index: number) {
    this.selectedIndex = index;
    this.companyName = item.companyname;
    this.maxPower = item.MaxPower;
    this.inverterSerialID = item.InverterSerialID;

    inverterService
      .getInverterCompanyById(item.CompanyID)
      .then((response: any) => {
        this.initializeBool(response.data);
        this.inverterCompanyDetail = response.data;
        // console.log(JSON.stringify(this.inverterCompanyDetail));
        if (this.inverterCompanyDetail.length == 0) {
          this.notFound = "Coming Soon";
        }
      });
  }
  initializeBool(data) {
    data.forEach((element, index) => {
      if (typeof element.values == "boolean") {
        if (element.values == true) {
          this.values[index] = true;
        } else {
          this.values[index] = false;
        }
      }
    });
  }
  getDevice() {
    plantService.getDevice(this.plantID).then((res: any) => {
      // alert(JSON.stringify(res.data.name));
      this.deviceID = res.data.name;
    });
  }
  getValues() {
    this.data = [];
    this.inverterCompanyDetail.forEach((item: any, index: number) => {
      this.data.push({
        register_no: item.register_number,
        value: this.values[index] ? this.values[index] : "",
      });
    });
    let data = {
      id: this.inverterSerialID,
      device_id: this.deviceID,
      data: this.data,
    };
    // alert(JSON.stringify(data));
    inverterService.saveManagedInverter(data).then((response: any) => {
      // console.log(response);
      if (response.meta.status_code == 200) {
        this.$toasted.global.throw({
          message: response.meta.message,
        });
      } else {
        this.$toasted.global.throw({
          message: response.meta.message,
        });
      }
    });
  }

  cancel() {
    this.values = {};
    this.selectedIndex = null;
    // alert(this.values[0]);
  }
}
